import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogCancelReservation = ({
	dialog, cancelReservation
}) => {
	return (
		<DialogAlertAction
			show={dialog.value}
			toggleShow={dialog.toggle}
			width="640px"
			widthContent="100%"
			spacingContainer="20px"
			variant="secondary"
			title="¿Deseas cancelar esta reserva?"
			content="Recuerda que al cancelar una reserva, deberás haber coordinado previamente con el alumno.">
			<CustomButton
				variant="secondary"
				text="No, mantener"
				width="140px"
				onClick={dialog.hide} />
			<CustomButton
				text="Si, cancelar"
				width="140px"
				onClick={cancelReservation} />
		</DialogAlertAction>
	);
}

export default DialogCancelReservation;